<template lang="pug">
  shListData(title="Labels History" resolver="labelsHistory" keyData="_id" component="shLabel" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'LabelsHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/label/LabelsHistory.vue